module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Bold.720d365a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Bold.svg
// module id = 351
// module chunks = 3